const xYearsFromNow = (x: number) => {
    const now = new Date();
    return new Date(now.getFullYear() + x, now.getMonth(), now.getDate());
};

export default xYearsFromNow;